module.exports = __webpack_public_path__ + "img/reget.64fe1ee1.svg";